import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { X, Cookie } from "lucide-react";

const CONSENT_KEY = "lgpd-consent";

type ConsentChoice = "accepted" | "rejected" | null;

export function ConsentBanner() {
  const [choice, setChoice] = useState<ConsentChoice>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) {
      const timer = setTimeout(() => setVisible(true), 500);
      return () => clearTimeout(timer);
    }
    setChoice(stored as ConsentChoice);
  }, []);

  useEffect(() => {
    function handleReset() {
      localStorage.removeItem(CONSENT_KEY);
      setChoice(null);
      setVisible(true);
    }
    window.addEventListener("lgpd-consent-reset", handleReset);
    return () => window.removeEventListener("lgpd-consent-reset", handleReset);
  }, []);

  function handleAccept() {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setChoice("accepted");
    setVisible(false);
  }

  function handleReject() {
    localStorage.setItem(CONSENT_KEY, "rejected");
    setChoice("rejected");
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-card p-4 shadow-lg animate-in slide-in-from-bottom">
      <div className="mx-auto flex max-w-7xl flex-col items-start gap-4 md:flex-row md:items-center md:justify-between">
        <div className="flex items-start gap-3 md:items-center">
          <Cookie className="mt-0.5 h-5 w-5 shrink-0 text-primary md:mt-0" />
          <div className="text-sm text-muted-foreground">
            <p>
              Utilizamos cookies e tecnologias semelhantes para melhorar sua experiência,
              analisar tráfego e personalizar conteúdo. Ao continuar navegando, você
              concorda com nossa{" "}
              <a
                href="/privacidade/politica-de-privacidade.html"
                className="font-medium text-foreground underline underline-offset-4 hover:text-primary"
              >
                Política de Privacidade
              </a>.
            </p>
          </div>
        </div>

        <div className="flex shrink-0 items-center gap-2">
          <Button variant="outline" size="sm" onClick={handleReject}>
            Recusar
          </Button>
          <Button size="sm" onClick={handleAccept}>
            Aceitar
          </Button>
          <button
            type="button"
            onClick={() => setVisible(false)}
            className="ml-1 rounded-sm p-1 text-muted-foreground opacity-70 hover:opacity-100"
          >
            <X className="h-4 w-4" />
            <span className="sr-only">Fechar</span>
          </button>
        </div>
      </div>
    </div>
  );
}
